import SponsorMemberForm from "../components/sponsorMember/main";

const SponsorMember = () => {
  return <SponsorMemberForm />;
};

export default SponsorMember;
